module.exports = __webpack_public_path__ + "img/PCT11.4f528335.svg";